module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title-select-ship":"Select trips","round-trip":"Roundtrip","station-donggang":"Donggang","station-liuqiu":"Liuqiu"},"zh-TW":{"title-select-ship":"選擇船班時間","round-trip":"來回票","station-donggang":"東港","station-liuqiu":"小琉球"}}')
  delete Component.options._Ctor
}
